<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (browserType !== 2) {
  <div
    class="toggle-switch-wrapper"
    [ngClass]="{ 'web-portal': !isMfd, disabled: disabled }">
    <div
      class="xrxToggleSwitch icon-button"
      [ngClass]="{ 'web-portal': !isMfd }"
      (mousedown)="onClick($event)"
      (mouseup)="onUnClick($event)"
      (mouseenter)="mouseStatus = MouseEventType.Hovered"
      (mouseleave)="onLeave($event)"
      (mousemove)="onDrag($event)">
      @if (image) {
        <span class="xrx-toggle-image"><img [src]="image" /></span>
      }
      @if (icon) {
        <span class="xrx-icon-sm" [ngClass]="icon ? icon : 'globe'"></span>
      }
      @if (glyph) {
        <i [ngClass]="glyph ? glyph : ''"></i>
      }
      @if (label) {
        <span class="xrxLabel" [xdaTranslate]="label"></span>
      }
      <div class="cb" [ngClass]="{ 'web-portal': !isMfd }">
        <div
          class="has-switch init"
          [ngClass]="{
            'switch-sm': !isMfd,
            on: switchOn,
            off: !switchOn,
            'web-portal': !isMfd,
          }">
          <i class="switch-glyph xgl-checkmark"></i>
          <div
            #switch
            class="switch-container"
            [ngClass]="{
              'switch-animate': mouseStatus != MouseEventType.Pressed,
              'switch-on': switchOn,
              'switch-off': !switchOn,
              'web-portal': !isMfd,
            }">
            <input
              class="xrx-switch"
              [ngClass]="{ 'switch-sm': !isMfd }"
              type="checkbox"
              checked=""
              [attr.aria-label]="switchOn ? 'on' : 'off'" />
            <span class="switch-left"></span>
            <label>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </label>
            <span class="switch-right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (browserType === 2) {
  <div class="toggle-switch-wrapper" [ngClass]="{ disabled: disabled }">
    <div class="xrxToggleSwitch icon-button" (tap)="onTap($event)">
      @if (image) {
        <span class="xrx-toggle-image"><img [src]="image" /></span>
      }
      @if (icon) {
        <span class="xrx-icon-sm" [ngClass]="icon ? icon : 'globe'"></span>
      }
      @if (glyph) {
        <i [ngClass]="glyph ? glyph : ''"></i>
      }
      @if (label) {
        <span class="xrxLabel" [xdaTranslate]="label"></span>
      }
      <div
        class="cb tg"
        (mousedown)="onClick($event)"
        (mouseup)="onUnClick($event)"
        (mouseenter)="mouseStatus = MouseEventType.Hovered"
        (mouseleave)="onLeave($event)"
        (mousemove)="onDrag($event)">
        <div
          class="has-switch init tg"
          [ngClass]="{ on: switchOn, off: !switchOn }">
          <i class="switch-glyph xgl-checkmark tg"></i>
          <div
            #switch
            class="switch-container tg"
            [ngClass]="{
              'switch-animate': mouseStatus != MouseEventType.Pressed,
              'switch-on': switchOn,
              'switch-off': !switchOn,
            }">
            <input class="xrx-switch tg" type="checkbox" checked="" />
            <span class="switch-left tg"></span>
            <label class="tg">
              <div class="bar tg"></div>
              <div class="bar tg"></div>
              <div class="bar tg"></div>
            </label>
            <span class="switch-right tg"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
